"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSymbol = exports.SYMBOL_MAP = exports.getLabel = exports.LABEL_MAP_PLURAL = exports.LABEL_MAP_SINGULAR = exports.Count = exports.Rational = exports.Integer = exports.NAMESPACE = void 0;
const effect_1 = require("effect");
exports.NAMESPACE = 'Unit.Count';
exports.Integer = effect_1.Schema.TaggedStruct('Integer', {
    amount: effect_1.Schema.NonNegative.pipe(effect_1.Schema.int()),
}).annotations({
    identifier: `${exports.NAMESPACE}.Integer`,
});
exports.Rational = effect_1.Schema.TaggedStruct('Rational', {
    amount: effect_1.Schema.NonNegative,
}).annotations({
    identifier: `${exports.NAMESPACE}.Rational`,
});
exports.Count = effect_1.Schema.Union(exports.Integer, exports.Rational).annotations({ identifier: `${exports.NAMESPACE}.Count` });
exports.LABEL_MAP_SINGULAR = {
    Integer: 'piece',
    Rational: 'piece',
};
exports.LABEL_MAP_PLURAL = {
    Integer: 'pieces',
    Rational: 'pieces',
};
const getLabel = (count) => count.amount === 1 ? exports.LABEL_MAP_SINGULAR[count._tag] : exports.LABEL_MAP_PLURAL[count._tag];
exports.getLabel = getLabel;
exports.SYMBOL_MAP = {
    Integer: 'pcs',
    Rational: 'pcs',
};
/**
 * Retrieves the symbol corresponding to a given {@link Count}-tag
 */
const getSymbol = (tag) => exports.SYMBOL_MAP[tag];
exports.getSymbol = getSymbol;
//# sourceMappingURL=count.js.map